import { render } from "./buySponsorsAccounts.vue?vue&type=template&id=0f0c7172"
import script from "./buySponsorsAccounts.vue?vue&type=script&lang=js"
export * from "./buySponsorsAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__